<template>
  <div class="home">
    <navbar/> 
    <home/>
  </div>
</template>

<script>

import home from '@/components/home.vue';
import navbar from '@/components/navbar.vue';
export default {
  name: 'HomeView',
  components: {
    home, 
    navbar
  }
}
</script>
